
import { defineComponent } from "vue";
import { IonList, IonItem, IonSkeletonText } from "@ionic/vue";
export default defineComponent({
  components: { IonList, IonItem, IonSkeletonText },
});
